import React, { Component } from 'react';
import $ from 'jquery'

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      isBurgerMenu: false
    }
    this.getElementY = this.getElementY.bind(this)
  }

  componentDidMount() {
    $(window).scroll(function(){
      if ($(this).scrollTop()+80 < $('#about-section')[0].offsetTop) {
        $('#navHome').addClass('active')
      } else {
        $('#navHome').removeClass('active')
      }

      if ($(this).scrollTop()+80 > $('#about-section')[0].offsetTop && $(this).scrollTop()+80 < $('#speakers-section')[0].offsetTop) {
        $('#navAbout').addClass('active')
      } else {
        $('#navAbout').removeClass('active')
      }

      if ($(this).scrollTop()+80 > $('#speakers-section')[0].offsetTop && $(this).scrollTop()+80 < $('#schedule-section')[0].offsetTop) {
        $('#navTeam').addClass('active')
      } else {
        $('#navTeam').removeClass('active')
      }

      // if ($(this).scrollTop()+80 > $('#pricing-section')[0].offsetTop && $(this).scrollTop()+80 < $('#schedule-section')[0].offsetTop) {
      //   $('#navPrice').addClass('active')
      // } else {
      //   $('#navPrice').removeClass('active')
      // }

      if ($(this).scrollTop()+80 > $('#schedule-section')[0].offsetTop && $(this).scrollTop()+80 < $('#contact-section')[0].offsetTop) {
        $('#navTestimoni').addClass('active')
      } else {
        $('#navTestimoni').removeClass('active')
      }

      if ($(this).scrollTop()+80 > $('#contact-section')[0].offsetTop) {
        $('#navContact').addClass('active')
      } else {
        $('#navContact').removeClass('active')
      }

			var $w = $(this),
				st = $w.scrollTop(),
				navbar = $('.ftco_navbar'),
				sd = $('.js-scroll-wrap');

			if (st > 150) {
				if ( !navbar.hasClass('scrolled') ) {
					navbar.addClass('scrolled');	
				}
			} 
			if (st < 150) {
				if ( navbar.hasClass('scrolled') ) {
					navbar.removeClass('scrolled sleep');
				}
			} 
			if ( st > 350 ) {
				if ( !navbar.hasClass('awake') ) {
					navbar.addClass('awake');	
				}
				
				if(sd.length > 0) {
					sd.addClass('sleep');
				}
			}
			if ( st < 350 ) {
				if ( navbar.hasClass('awake') ) {
					navbar.removeClass('awake');
					navbar.addClass('sleep');
				}
				if(sd.length > 0) {
					sd.removeClass('sleep');
				}
			}
		});
  }

  getElementY(query) {
    return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
  }  

  doScrolling(element) {
    let duration = 1500
    var startingY = window.pageYOffset
    var elementY = this.getElementY(element)
    // If element is close to page's bottom then window will scroll only to some position above the element.
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
    var diff = targetY - startingY
    // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294
    var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
    var start
  
    if (!diff) return
  
    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp
      // Elapsed miliseconds since start of scrolling.
      var time = timestamp - start
      // Get percent of completion in range [0, 1].
      var percent = Math.min(time / duration, 1)
      // Apply the easing.
      // It can cause bad-looking slow frames in browser performance tool, so be careful.
      percent = easing(percent)
  
      window.scrollTo(0, startingY + diff * percent)
  
      // Proceed with animation as long as we wanted it to.
      if (time < duration) {
        window.requestAnimationFrame(step)
      }
    })
  }

  clickBurgerMenu() {
    if (this.state.isShow === false) {
      $("#ftco-nav").slideDown("fast")   
    } else {
      $("#ftco-nav").slideUp("fast")
    }
    this.setState({isShow: !this.state.isShow})
    this.setState({isBurgerMenu: true})
  }

  render() { 
    return (
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light site-navbar-target" id="ftco-navbar">
        <div className="container">
          <img src={require('../assets/images/samawa.png')} style={{width: '115px', padding: '5px 0px'}}></img>
          <button className="navbar-toggler js-fh5co-nav-toggle fh5co-nav-toggle" onClick={() => this.clickBurgerMenu()}>
            <span className="oi oi-menu"></span> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav nav ml-auto">
              <li className="nav-item" style={{cursor: 'pointer'}} onClick={() => this.doScrolling('#home-section')}>
                <a id="navHome" className="nav-link active"><span>Home</span></a>
              </li>
              <li className="nav-item" style={{cursor: 'pointer'}} onClick={() => this.doScrolling('#about-section')}>
                <a id="navAbout" className="nav-link"><span>About</span></a>
              </li>
              <li className="nav-item" style={{cursor: 'pointer'}} onClick={() => this.doScrolling('#speakers-section')}>
                <a id="navTeam" className="nav-link"><span>Teams</span></a>
              </li>
              {/* <li className="nav-item" style={{cursor: 'pointer'}} onClick={() => this.doScrolling('#pricing-section')}>
                <a id="navPrice" className="nav-link"><span>Pricing</span></a>
              </li> */}
              <li className="nav-item" style={{cursor: 'pointer'}} onClick={() => this.doScrolling('#schedule-section')}>
                <a id="navTestimoni" className="nav-link"><span>Template</span></a>
              </li>
              <li className="nav-item" style={{cursor: 'pointer'}} onClick={() => this.doScrolling('#contact-section')}>
                <a id="navContact" className="nav-link"><span>Contact</span></a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
 
export default Header;